// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../../../../../node_modules/@glennsl/bs-json/src/Json.bs.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../Config.bs.js";
import * as CrmNetwork from "../../../../../library/network/CrmNetwork.bs.js";
import * as CountryConfig from "../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DriverLeadRepoConfig from "./DriverLeadRepoConfig.bs.js";
import * as DriverLeadPayloadModel from "../api-model/DriverLeadPayloadModel.bs.js";

function fetchDriverLeadBasicInfo(driver_number, country) {
  var url = Config.Env.getHostName(undefined) + "/administrators/leads/fetch_basic_details";
  var payload = Json.stringify(DriverLeadPayloadModel.t_encode({
            mobiles: driver_number.split(",")
          }));
  return CrmNetwork.post(url, undefined, {
                country: CountryConfig.countryToString(country)
              }, payload, undefined, /* Include */2, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverLeadRepoConfig.DriverLeadResponseConverter.execute, result);
                        });
            });
}

function fetchDriverPaymentHistory(lead_id, country) {
  var url = Config.Env.getHostName(undefined) + ("/administrators/lead/payment_history/" + lead_id);
  return CrmNetwork.get(url, "/administrators/lead/payment_history/:lead_id", {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(DriverLeadRepoConfig.DriverPaymentHistoryResponseConverter.execute, result);
                        });
            });
}

var DriverLeadRepo = {
  fetchDriverLeadBasicInfo: fetchDriverLeadBasicInfo,
  fetchDriverPaymentHistory: fetchDriverPaymentHistory
};

export {
  DriverLeadRepo ,
  
}
/* Config Not a pure module */
